<template>
<Transition name="modal">
<div v-if="show" class="modal-mask">
    <div class="modal-wrapper">
    <div class="modal-container">
        <div class="modal-header">
        <slot name="header">
            <button class="btn btn-outline-primary"
            color="darkgreen" size="small" type="border" icon="close"
            @click="$emit('close')"
            >Cerrar</button>
        </slot>
        </div>

        <div class="modal-body-container">
            <slot name="body">
            </slot>
        </div>
    </div>
    </div>
</div>
</Transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
  }
}
</script>

<style>
.btn-outline-primary {
    color: darkgreen;
    background-color: transparent;
    background-image: none;
    border-color: darkgreen;
    border-radius: 4px !important;
}

.btn-outline-primary:hover {
    color: white;
    background-color: darkgreen;
    border-color: darkgreen
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
    box-shadow: none !important;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
    color: darkgreen;
    background-color: transparent
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show>.btn-outline-primary.dropdown-toggle {
    color: white;
    background-color: darkgreen;
    border-color: darkgreen
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
    box-shadow: none !important;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 80vw; /* Por ejemplo, 80% del ancho de la ventana */
  height: 80vh; /* Y 80% del alto de la ventana para un buen espacio */
  max-width: 900px; /* Un máximo deseado */
  max-height: 700px; /* Un máximo deseado */
  margin: 0px auto;
  margin-top: 70px; /* O el que desees */
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex; /* Añadir flexbox para centrar el contenido */
  flex-direction: column; /* Contenido en columna */
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-header{
  justify-content: right;
}

.modal-body-container {
  flex-grow: 1; /* Ocupa todo el espacio disponible en el modal-container */
  width: 100%;
  /* height: 80%; <--- Elimina esta línea si está fija, ya que flex-grow es mejor */
  text-align: center;
  display: flex; /* Añadir flexbox para centrar la imagen */
  justify-content: center; /* Centra horizontalmente */
  align-items: center; /* Centra verticalmente */
}
.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>